var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletInt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#F2F2F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2256 11.5643C14.9742 11.3129 14.5489 11.3129 14.2975 11.5643L10.4305 15.4313L8.43901 13.4398C8.01364 13.0144 7.31759 13.3237 7.31759 13.9038L7.29825 20.6904C7.29825 21.0771 7.58828 21.3671 7.95564 21.3478H14.7615C15.3416 21.3478 15.6509 20.6517 15.2256 20.2263L13.2147 18.2155L17.0817 14.3485C17.3331 14.0971 17.3524 13.6911 17.0817 13.4204L15.2256 11.5643Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7725 21.4357C19.0238 21.6871 19.4492 21.6871 19.7005 21.4357L23.5675 17.5687L25.559 19.5602C25.9844 19.9856 26.6805 19.6763 26.6805 19.0962L26.6998 12.3096C26.6998 11.9229 26.4098 11.6329 26.0424 11.6522H19.2365C18.6565 11.6522 18.3471 12.3483 18.7725 12.7737L20.7833 14.7845L16.9163 18.6515C16.665 18.9029 16.6456 19.3089 16.9163 19.5796L18.7725 21.4357Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletInt);
export default __webpack_public_path__ + "static/media/walletInt.bc0c592b.svg";
export { ForwardRef as ReactComponent };